import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29a5f456")

_pushScopeId("data-v-29a5f456")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("扣费说明")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" (相同车辆可能存在 基础和收费车辆 两笔扣费) ")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_c_table = _resolveComponent("c-table")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "扣费详情",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "850px",
    "destroy-on-close": "",
    "before-close": _ctx.handleClose
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_6, [
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        class: "formRef",
        ref: "formRef",
        "label-width": "110px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, null, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费编号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.uuid || '-'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "企业编号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.enterpriseCode || '-'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费企业：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.companyName || '-'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider, { "content-position": "left" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "费用项目：" }, {
                    default: _withId(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.feeType[_ctx.form.feeType]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "数量：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.amount), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "单价（元）：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.price) + " 元 ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "车辆数：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.carNum), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "费率：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.rate) + " % ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "实扣费用：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.fee) + " 元 ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "创建时间：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.createTime || '-'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费状态：" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_tag, {
                        type: _ctx.form.state === 1 ? 'success' : 'danger'
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.state[_ctx.form.state]), 1)
                        ]),
                        _: 1
                      }, 8, ["type"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费时间：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.deductTime || '-'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "原因说明：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.reason[_ctx.form.reason] || '-'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "缴费类型：" }, {
                    default: _withId(() => [
                      (_ctx.form.paymentType === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_2, "按年"))
                        : _createCommentVNode("", true),
                      (_ctx.form.paymentType === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_3, "按天"))
                        : _createCommentVNode("", true),
                      (_ctx.form.paymentType === 3)
                        ? (_openBlock(), _createBlock("span", _hoisted_4, "按次"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费明细：" }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.istable)
            ? (_openBlock(), _createBlock(_component_c_table, {
                key: 0,
                dataSource: _ctx.tableConfig
              }, null, 8, ["dataSource"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
})